"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isMobile = _interopRequireDefault(require("@ux/component-utilities/is-mobile"));
var _valueLabel = _interopRequireDefault(require("./value-label"));
const _excluded = ["breakpoint", "shouldRenderLabels", "range", "value", "valueLabels", "clientWidth"];
/**
 * Returns rendered value labels wrapped in a div.
 * @param {React.ComponentPropsWithoutRef} props component props
 * @returns {React.ReactElement} Rendered value labels
 * @private
 */
function ValueLabels(_ref) {
  let {
      breakpoint,
      shouldRenderLabels,
      range,
      value,
      valueLabels,
      clientWidth
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  // if there are labels, there should be no value labels
  // on mobile, there should be no value labels
  if (!shouldRenderLabels && !(0, _isMobile.default)(breakpoint)) {
    let values = [];
    if (range && Array.isArray(value)) {
      values = value.filter((val, index) => valueLabels[index]);
    } else if (valueLabels[0]) {
      values = [value];
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "ux-slider-value-labels"
    }, values.map((val, index) => {
      return /*#__PURE__*/_react.default.createElement(_valueLabel.default, (0, _extends2.default)({
        key: `value-label-${index}`,
        index: index,
        value: val,
        clientWidth: clientWidth
      }, props));
    }));
  }
  return null;
}
ValueLabels.propTypes = {
  breakpoint: _propTypes.default.string,
  shouldRenderLabels: _propTypes.default.bool,
  range: _propTypes.default.bool,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
  valueLabels: _propTypes.default.array,
  clientWidth: _propTypes.default.number,
  rtl: _propTypes.default.bool,
  step: _propTypes.default.number,
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  tooltipLabels: _propTypes.default.array,
  format: _propTypes.default.func
};
var _default = exports.default = ValueLabels;